import { Box } from '@rebass/grid';
import styled, { css } from 'styled-components';

import { Heading3 } from 'app/shared/ui';
import { media } from 'app/shared/ui/components/variables/media';

export const Container = styled(Box).attrs(() => ({
  as: 'section',
  pt: [30, 56, 64],
  px: [16, 28, 36, 156],
  pb: [64, 36, 64, 74],
}))`
  text-align: center;
`;

export const Header = styled(Box).attrs(() => ({
  as: 'header',
  mb: [32, 40],
}))``;

export const Heading = styled(Heading3).attrs(() => ({
  fontSize: [24, 28],
}))``;

export const Text = styled.span`
  font-size: 14px;
`;

export const Content = styled(Box)`
  display: grid;
  row-gap: 16px;

  ${media.md(css`
    grid-template-columns: repeat(2, 1fr);
    column-gap: 32px;
  `)}
`;
